export var Type;
(function (Type) {
    Type["AnchoredVector3D"] = "AnchoredVector3D";
    Type["ArrayND"] = "ArrayND";
    Type["Blob"] = "Blob";
    Type["Boolean"] = "Boolean";
    Type["Box2D"] = "Box2D";
    Type["Box3D"] = "Box3D";
    Type["Bytes"] = "Bytes";
    Type["CameraExtrinsics"] = "CameraExtrinsics";
    Type["CameraIntrinsics"] = "CameraIntrinsics";
    Type["CameraParameters"] = "CameraParameters";
    Type["Float32"] = "Float32";
    Type["Float64"] = "Float64";
    Type["Image2D"] = "Image2D";
    Type["Integer16"] = "Integer16";
    Type["Integer32"] = "Integer32";
    Type["Integer64"] = "Integer64";
    Type["Integer8"] = "Integer8";
    Type["Label"] = "Label";
    Type["List"] = "List";
    Type["Mask2D"] = "Mask2D";
    Type["Mask3D"] = "Mask3D";
    Type["None"] = "None";
    Type["Object"] = "Object";
    Type["Plane"] = "Plane";
    Type["Point2D"] = "Point2D";
    Type["Point3D"] = "Point3D";
    Type["PointCloud3D"] = "PointCloud3D";
    Type["PointCloudMask"] = "PointCloudMask";
    Type["Polygon2D"] = "Polygon2D";
    Type["Polygon3D"] = "Polygon3D";
    Type["Polyline2D"] = "Polyline2D";
    Type["Polyline3D"] = "Polyline3D";
    Type["Pose2D"] = "Pose2D";
    Type["Pose3D"] = "Pose3D";
    Type["RigidTransformation3D"] = "RigidTransformation3D";
    Type["SemanticVersion"] = "SemanticVersion";
    Type["Size2D"] = "Size2D";
    Type["Size3D"] = "Size3D";
    Type["Sphere"] = "Sphere";
    Type["Text"] = "Text";
    Type["Timestamp"] = "Timestamp";
    Type["TriangleMesh3D"] = "TriangleMesh3D";
    Type["Unknown"] = "Unknown";
    Type["UnsignedInteger16"] = "UnsignedInteger16";
    Type["UnsignedInteger32"] = "UnsignedInteger32";
    Type["UnsignedInteger64"] = "UnsignedInteger64";
    Type["UnsignedInteger8"] = "UnsignedInteger8";
    Type["URI"] = "URI";
    Type["Vector2D"] = "Vector2D";
    Type["Vector3D"] = "Vector3D";
})(Type || (Type = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvVHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxJQW1EWDtBQW5ERCxXQUFZLElBQUk7SUFDZCw2Q0FBcUMsQ0FBQTtJQUNyQywyQkFBbUIsQ0FBQTtJQUNuQixxQkFBYSxDQUFBO0lBQ2IsMkJBQW1CLENBQUE7SUFDbkIsdUJBQWUsQ0FBQTtJQUNmLHVCQUFlLENBQUE7SUFDZix1QkFBZSxDQUFBO0lBQ2YsNkNBQXFDLENBQUE7SUFDckMsNkNBQXFDLENBQUE7SUFDckMsNkNBQXFDLENBQUE7SUFDckMsMkJBQW1CLENBQUE7SUFDbkIsMkJBQW1CLENBQUE7SUFDbkIsMkJBQW1CLENBQUE7SUFDbkIsK0JBQXVCLENBQUE7SUFDdkIsK0JBQXVCLENBQUE7SUFDdkIsK0JBQXVCLENBQUE7SUFDdkIsNkJBQXFCLENBQUE7SUFDckIsdUJBQWUsQ0FBQTtJQUNmLHFCQUFhLENBQUE7SUFDYix5QkFBaUIsQ0FBQTtJQUNqQix5QkFBaUIsQ0FBQTtJQUNqQixxQkFBYSxDQUFBO0lBQ2IseUJBQWlCLENBQUE7SUFDakIsdUJBQWUsQ0FBQTtJQUNmLDJCQUFtQixDQUFBO0lBQ25CLDJCQUFtQixDQUFBO0lBQ25CLHFDQUE2QixDQUFBO0lBQzdCLHlDQUFpQyxDQUFBO0lBQ2pDLCtCQUF1QixDQUFBO0lBQ3ZCLCtCQUF1QixDQUFBO0lBQ3ZCLGlDQUF5QixDQUFBO0lBQ3pCLGlDQUF5QixDQUFBO0lBQ3pCLHlCQUFpQixDQUFBO0lBQ2pCLHlCQUFpQixDQUFBO0lBQ2pCLHVEQUErQyxDQUFBO0lBQy9DLDJDQUFtQyxDQUFBO0lBQ25DLHlCQUFpQixDQUFBO0lBQ2pCLHlCQUFpQixDQUFBO0lBQ2pCLHlCQUFpQixDQUFBO0lBQ2pCLHFCQUFhLENBQUE7SUFDYiwrQkFBdUIsQ0FBQTtJQUN2Qix5Q0FBaUMsQ0FBQTtJQUNqQywyQkFBbUIsQ0FBQTtJQUNuQiwrQ0FBdUMsQ0FBQTtJQUN2QywrQ0FBdUMsQ0FBQTtJQUN2QywrQ0FBdUMsQ0FBQTtJQUN2Qyw2Q0FBcUMsQ0FBQTtJQUNyQyxtQkFBVyxDQUFBO0lBQ1gsNkJBQXFCLENBQUE7SUFDckIsNkJBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQW5EVyxJQUFJLEtBQUosSUFBSSxRQW1EZiJ9